export default __webpack_public_path__ + "static/media/berenice-krzyzaniak-boudot-cv.549abee8.pdf";